//
// Copyright (c) 2011-2020 by Curalate, Inc.
//

import { IScheduledTweet } from '@apis/universal-posts/scheduled-posts/universalScheduledPostsApiModel';
import DateString from '@models/DateString';
import PostableId from '@models/PostableId';
import { Normalized } from '@utils/normalize';

// TODO: Update this once twitter task is added (DEV-56657)
export const TWITTER_SCHEDULE_TASK_NAME = 'publish:schedule_instagram_item';

export const SCHEDULE_TWEET_FETCH_LIMIT = 80;

export interface ITwitterScheduleState {
  scheduledTweets: NormalizedScheduledTweets;
  startDate: DateString;

  errors: {
    fetchScheduledTweetsError?: string;
  };
  flags: {
    isFetchingScheduledTweets: boolean;
    isInitialScheduleDataLoaded: boolean;
    isDeletingTweet: boolean;
  };
}

export type NormalizedScheduledTweets = Normalized<IScheduledTweet, PostableId>;

export interface ITimelineTweetGroup {
  date: DateString;
  items: IScheduledTweet[];
}
